import { api, ApiError } from '../api/client';
import type { SmsFlowStatus } from '../ui/smsStatusFlow';

export interface SmsDeliveryCatchUpResult {
  status: SmsFlowStatus;
  errorDescription: string | null;
  cmStatusCode: number | null;
}

function toFlowStatus(status: string): SmsFlowStatus {
  switch (status) {
    case 'accepted':
      return 'accepted';
    case 'failed':
      return 'failed';
    case 'delivered':
      return 'delivered';
    default:
      return 'pending';
  }
}

/**
 * Fetch current delivery status after send. A 404 means the row was removed by a
 * delivered webhook that raced ahead of the live socket — treat as delivered.
 */
export async function catchUpSmsDeliveryStatus(
  reference: string,
): Promise<SmsDeliveryCatchUpResult> {
  try {
    const delivery = await api.getSmsDelivery(reference);
    return {
      status: toFlowStatus(delivery.status),
      errorDescription: delivery.errorDescription,
      cmStatusCode: delivery.cmStatusCode,
    };
  } catch (cause) {
    if (cause instanceof ApiError && cause.status === 404) {
      return {
        status: 'delivered',
        errorDescription: null,
        cmStatusCode: 2,
      };
    }
    throw cause;
  }
}
